import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Header from './layout/Header';
import Menu from './layout/Menu';
import Footer from './layout/Footer';

import Usuarios from '../src/components/usuarios/Index';
import CrearUsuario from '../src/components/usuarios/Crear';
import EditarUsuario from '../src/components/usuarios/Editar';

import Roles from '../src/components/roles/Index';
import CrearRol from '../src/components/roles/Crear';
import EditarRol from '../src/components/roles/Editar';

import Pacientes from './components/pacientes/Index';
import AddPaciente from './components/pacientes/Crear';
import EditPacientes from './components/pacientes/Editar';

import Categorias from './components/categorias/Index';
import AddCategoria from './components/categorias/Crear';
import EditCategorias from './components/categorias/Editar';

import Servicios from './components/servicios/Index';
import AddServicio from './components/servicios/Crear';
import EditServicios from './components/servicios/Editar';

import Doctores from './components/doctores/Index';
import AddDoctor from './components/doctores/Crear';
import EditDoctores from './components/doctores/Editar';

import HistoriasClinicas from '../src/components/historias_clinicas/Index';
import AddHistoriaClinica from '../src/components/historias_clinicas/Crear';
import EditHistoriasClinicas from '../src/components/historias_clinicas/Editar';

import Citas from './components/citas/Index';
import AddCita from './components/citas/Crear';
import EditCitas from './components/citas/Editar';

import Facturas from '../src/components/facturas/Index';
import AddFactura from '../src/components/facturas/Crear';
import EditFactura from '../src/components/facturas/Editar';

//Acá pa abajo se borra\\

import Suppliers from './components/suppliers/Index';
import AddSupplier from './components/suppliers/Crear';
import EditSupplier from './components/suppliers/Editar';

import Quotations from '../src/components/quotations/Index';
import AddQuotation from '../src/components/quotations/Crear';
import EditQuotation from '../src/components/quotations/Editar';

import Invoices from '../src/components/invoices/Index';
import AddInovice from '../src/components/invoices/Crear';
import EditInovice from '../src/components/invoices/Editar';

import SuppliersInvoices from '../src/components/suppliers_invoices/Index';
import AddSupplierInovice from '../src/components/suppliers_invoices/Crear';
import EditSupplierInovice from '../src/components/suppliers_invoices/Editar';

import Accounting from '../src/components/accounting/Index';
import AddAccounting from '../src/components/accounting/Crear';
import EditAccounting from '../src/components/accounting/Editar';

import Movements from '../src/components/movements/Index';
import AddMovement from '../src/components/movements/Crear';
import EditMovement from '../src/components/movements/Editar';

//Hasta acá\\

import MenuConfiguracion from '../src/components/menuconfiguracion/Index';
import EditarConfiguracion from '../src/components/menuconfiguracion/Editar';
import AddConfiguracion from '../src/components/menuconfiguracion/Crear';

import ListaTablas from '../src/components/MenuPrincipal/Index';
import Master from '../src/components/Master/Listar';

import ConsultasBasicas from './components/consultas_basicas/Index';
import ReportePQR from './components/pqr/Consultar';

import Home from './components/home/Index';
function App() {
  const ux = localStorage.getItem("username");
  return (
    
    <Router>
      {ux != null ? <Header /> : ''}
      {ux != null ? <Menu /> : ''}
      {ux != null ? <Route exact path="/" component={Home}></Route> :
        <Route exact path="/" component={Login}></Route>}

        <Route exact path="/pages/:id" component={ux != null ? Master : Login}></Route> 
        <Route exact path="/home" component={ux != null ? Home : Login}></Route> 
       <Route exact path="/MenuConfiguracion" component={ux != null ? MenuConfiguracion : Login}></Route> 
       <Route exact path="/EditarConfiguracion/:id" component={ux != null ? EditarConfiguracion : Login}></Route>
       <Route exact path="/AddConfiguracion" component={ux != null ? AddConfiguracion : Login}></Route>

       <Route exact path="/Tablas/:id" component={ux != null ? ListaTablas : Login}></Route> 

      <Route exact path="/MasterUsuarios" component={ux != null ? Usuarios : Login}></Route>
      <Route exact path="/AddUsuarios" component={ux != null ? CrearUsuario : Login}></Route>
      <Route exact path="/UpUsuarios/:id" component={ux != null ? EditarUsuario : Login}></Route>

      <Route exact path="/MasterRoles" component={ux != null ? Roles : Login}></Route>
      <Route exact path="/AddRoles" component={ux != null ? CrearRol : Login}></Route>
      <Route exact path="/UpRoles/:id" component={ux != null ? EditarRol : Login}></Route>

      <Route exact path="/MasterPacientes" component={ux != null ? Pacientes : Login}></Route>
      <Route exact path="/AddPacientes" component={ux != null ? AddPaciente : Login}></Route>
      <Route exact path="/UpPacientes/:id" component={ux != null ? EditPacientes : Login}></Route>

      <Route exact path="/MasterCategorias" component={ux != null ? Categorias : Login}></Route>
      <Route exact path="/AddCategorias" component={ux != null ? AddCategoria : Login}></Route>
      <Route exact path="/UpCategorias/:id" component={ux != null ? EditCategorias : Login}></Route>

      <Route exact path="/MasterServicios" component={ux != null ? Servicios : Login}></Route>
      <Route exact path="/AddServicios" component={ux != null ? AddServicio : Login}></Route>
      <Route exact path="/UpServicios/:id" component={ux != null ? EditServicios : Login}></Route>

      <Route exact path="/MasterDoctores" component={ux != null ? Doctores : Login}></Route>
      <Route exact path="/AddDoctores" component={ux != null ? AddDoctor : Login}></Route>
      <Route exact path="/UpDoctores/:id" component={ux != null ? EditDoctores : Login}></Route>

      <Route exact path="/MasterHistoriasClinicas" component={ux != null ? HistoriasClinicas : Login}></Route>
      <Route exact path="/AddHistoriasClinicas" component={ux != null ? AddHistoriaClinica : Login}></Route>
      <Route exact path="/UpHistoriasClinicas/:id" component={ux != null ? EditHistoriasClinicas : Login}></Route>

      <Route exact path="/MasterCitas" component={ux != null ? Citas : Login}></Route>
      <Route exact path="/AddCitas" component={ux != null ? AddCita : Login}></Route>
      <Route exact path="/UpCitas/:id" component={ux != null ? EditCitas : Login}></Route>

      <Route exact path="/MasterFacturas" component={ux != null ? Facturas : Login}></Route>
      <Route exact path="/AddFacturas" component={ux != null ? AddFactura : Login}></Route>
      <Route exact path="/UpFacturas/:id" component={ux != null ? EditFactura : Login}></Route>

      <Route exact path="/MasterSuppliers" component={ux != null ? Suppliers : Login}></Route>
      <Route exact path="/AddSuppliers" component={ux != null ? AddSupplier : Login}></Route>
      <Route exact path="/UpSuppliers/:id" component={ux != null ? EditSupplier : Login}></Route>

      <Route exact path="/MasterQuotations" component={ux != null ? Quotations : Login}></Route>
      <Route exact path="/AddQuotations" component={ux != null ? AddQuotation : Login}></Route>
      <Route exact path="/UpQuotations/:id" component={ux != null ? EditQuotation : Login}></Route>

      <Route exact path="/MasterInvoices" component={ux != null ? Invoices : Login}></Route>
      <Route exact path="/AddInvoices" component={ux != null ? AddInovice : Login}></Route>
      <Route exact path="/UpInvoices/:id" component={ux != null ? EditInovice : Login}></Route>

      <Route exact path="/MasterSuppliersInvoices" component={ux != null ? SuppliersInvoices : Login}></Route>
      <Route exact path="/AddSuppliersInvoices" component={ux != null ? AddSupplierInovice : Login}></Route>
      <Route exact path="/UpSuppliersInvoices/:id" component={ux != null ? EditSupplierInovice : Login}></Route>

      <Route exact path="/MasterAccounting" component={ux != null ? Accounting : Login}></Route>
      <Route exact path="/AddAccounting" component={ux != null ? AddAccounting : Login}></Route>
      <Route exact path="/UpAccounting/:id" component={ux != null ? EditAccounting : Login}></Route>

      <Route exact path="/MasterMovements" component={ux != null ? Movements : Login}></Route>
      <Route exact path="/AddMovements" component={ux != null ? AddMovement : Login}></Route>
      <Route exact path="/UpMovements/:id" component={ux != null ? EditMovement : Login}></Route>

      <Route exact path="/MasterConsultasIngreso" component={ux != null ? ConsultasBasicas : Login}></Route>
      <Route exact path="/MasterConsultasPQR" component={ux != null ? ReportePQR : Login}></Route>

      {ux != null ? <Footer /> : ''}
    </Router>
  );
}

export default App;
